import { useEffect, useState } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Home from './pages/Home'
import Query from './pages/Query'
import Detail from './pages/Detail'
import Sender from './pages/Sender'
import Worker from './pages/Worker'
import Deliver from './pages/Deliver'
import CustomerOrders from './pages/CustomerOrders'
import TermsModal from './components/TermsModal'
import { authApi, configApi } from './services/api'

function TermsChecker({ children }: { children: React.ReactNode }) {
  const [needTerms, setNeedTerms] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (!token) {
      setNeedTerms(false)
      return
    }

    authApi.me().then((data: unknown) => {
      const d = data as { needAgreeTerms?: boolean }
      if (d.needAgreeTerms) {
        setNeedTerms(true)
      }
    }).catch(() => {
      // ignore
    })
  }, [location.pathname])

  return (
    <>
      {children}
      {needTerms && (
        <TermsModal
          onAgree={() => setNeedTerms(false)}
          onDecline={() => {
            localStorage.removeItem('token')
            setNeedTerms(false)
            window.location.reload()
          }}
        />
      )}
    </>
  )
}

function App() {
  const [thirdPartyEnabled, setThirdPartyEnabled] = useState(false)
  const [configLoaded, setConfigLoaded] = useState(false)

  useEffect(() => {
    configApi.getPublic()
      .then((cfg) => setThirdPartyEnabled(cfg.thirdPartyShipping))
      .catch(() => setThirdPartyEnabled(false))
      .finally(() => setConfigLoaded(true))
  }, [])

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#eeeeee' }}>
      <TermsChecker>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/customer/query" element={<Query />} />
          <Route path="/customer/orders" element={<CustomerOrders />} />
          <Route path="/detail/:orderNo" element={<Detail />} />
          <Route path="/sender" element={
            configLoaded && !thirdPartyEnabled
              ? <SenderDisabledPlaceholder />
              : <Sender />
          } />
          <Route path="/sender/:token" element={
            configLoaded && !thirdPartyEnabled
              ? <SenderDisabledPlaceholder />
              : <Sender />
          } />
          <Route path="/worker" element={<Worker />} />
          <Route path="/deliver" element={<Deliver />} />
        </Routes>
      </TermsChecker>
    </div>
  )
}

function SenderDisabledPlaceholder() {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '60vh', padding: '24px',
    }}>
      <p style={{
        fontFamily: '"Noto Sans SC", sans-serif',
        fontSize: '14px', color: '#9a9a9a',
        letterSpacing: '0.15em', textAlign: 'center',
      }}>
        该功能暂未开放
      </p>
    </div>
  )
}

export default App
